import React, { useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContainer from "@mui/material/TableContainer";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementTestimonial from "../../../core/api/api.amusementTestimonials";

export const AddEditeModal = ({ showModalTestimonial, setShowModalTestimonial, selectedTestimonial }) => {

  const [tabValue, setTabValue] = React.useState(0);

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    defaultValues: { id: 0 },
  });

  const {
    control: control2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2, isSubmitting: isSubmitting2 },
    setValue: setValue2,
  } = useForm({
    defaultValues: { id: 0 },
  });
  const handleClose = () => {
    setShowModalTestimonial(false);
  };

  useEffect(() => {
    (async () => {
      try {
        if (selectedTestimonial != null) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiAmusementTestimonial.getAmusementTestimonialById(selectedTestimonial);
          if (response.succeeded == true) {
            // مقدار اولیه ویرایش نظر
            setValue("id", response.data.id);
            setValue("text", response.data.text);
            setValue("worthBuying", response.data.worthBuying);
            setValue("qualityServices", response.data.qualityServices);
            setValue("isthriller", response.data.isthriller);
            // مقدار اولیه پاسخ نظر
            setValue2("name", "سامانه");
            setValue2("id", 0);
            setValue2("pAmusementTestimonialId", response.data.id);
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  function handleChange(event, newValue) {
    setTabValue(newValue);
  }

  const onSubmit = async (data) => {
    //------------------ ویرایش نظر ----------------------

    try {
      const response = await ApiAmusementTestimonial.updateAmusementTestimonial(data);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      handleClose();
    } catch (error) {
    }
  };

  const onSubmit2 = async (data) => {
    //------------------ ثبت پاسخ نظر ----------------------
    try {
      const response = await ApiAmusementTestimonial.createAmusementTestimonial(data);
      if (response.succeeded == true) document.getElementById("submitButton").click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      handleClose();
    } catch (error) {
    }
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" show={showModalTestimonial} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>ویرایش و پاسخ به نظر</Modal.Title>
        </Modal.Header>
        {tabValue === 0 && (
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
              <Paper className="tab-noStyle">
                <Tabs value={tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
                  <Tab label="ویرایش نظر" />
                  <Tab label="پاسخ به نظر" />
                </Tabs>
              </Paper>

              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <Row>
                    <Col xs="12">
                      <Controller
                        name="text"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="متن نظر"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            multiline
                            maxRows="10"
                            value={value || ""}
                            onInput={onChange}
                            sx={{
                              ".css-1ppugi6-MuiInputBase-root-MuiOutlinedInput-root": {
                                padding: "8.5px 14px 8.5px 0px !important",
                              }
                            }}
                          />
                        )}
                      />
                      {errors.text && <span>لطفا متنی را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="worthBuying"
                        control={control}
                        rules={{
                          required: "وارد کردن این مقدار الزامی است",
                          min: { value: 0, message: "عدد نمی‌تواند کمتر از 0 باشد" },
                          max: { value: 5, message: "عدد نمی‌تواند بیشتر از 5 باشد" },
                          pattern: {
                            value: /^[0-9]+$/, // فقط رقم (بدون اعشار)
                            message: "فقط عدد صحیح مجاز است",
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="ارزش خرید"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            type="number"                    // فقط عدد
                            value={value || ""}
                            onInput={(e) => {
                              // فقط اعداد صحیح بین 0 و 5
                              const val = e.target.value;
                              if (/^[0-9]*$/.test(val) && val >= 0 && val <= 5) {
                                onChange(val);
                              } else if (val === "") {
                                onChange("");
                              }
                            }}
                            inputProps={{ min: 0, max: 5 }}
                            error={!!errors.worthBuying}
                            helperText={errors.worthBuying?.message}
                          />
                        )}
                      />
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="qualityServices"
                        control={control}
                        rules={{
                          required: "وارد کردن این مقدار الزامی است",
                          min: { value: 0, message: "عدد نمی‌تواند کمتر از 0 باشد" },
                          max: { value: 5, message: "عدد نمی‌تواند بیشتر از 5 باشد" },
                          pattern: {
                            value: /^[0-9]+$/, // فقط رقم (بدون اعشار)
                            message: "فقط عدد صحیح مجاز است",
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="کیفیت خدمات"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            type="number"                    // فقط عدد
                            value={value || ""}
                            onInput={(e) => {
                              // فقط اعداد صحیح بین 0 و 5
                              const val = e.target.value;
                              if (/^[0-9]*$/.test(val) && val >= 0 && val <= 5) {
                                onChange(val);
                              } else if (val === "") {
                                onChange("");
                              }
                            }}
                            inputProps={{ min: 0, max: 5 }}
                            error={!!errors.qualityServices}
                            helperText={errors.qualityServices?.message}
                          />
                        )}
                      />
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="isthriller"
                        control={control}
                        rules={{
                          required: "وارد کردن این مقدار الزامی است",
                          min: { value: 0, message: "عدد نمی‌تواند کمتر از 0 باشد" },
                          max: { value: 5, message: "عدد نمی‌تواند بیشتر از 5 باشد" },
                          pattern: {
                            value: /^[0-9]+$/, // فقط رقم (بدون اعشار)
                            message: "فقط عدد صحیح مجاز است",
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="هیجان انگیزی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            type="number"                    // فقط عدد
                            value={value || ""}
                            onInput={(e) => {
                              // فقط اعداد صحیح بین 0 و 5
                              const val = e.target.value;
                              if (/^[0-9]*$/.test(val) && val >= 0 && val <= 5) {
                                onChange(val);
                              } else if (val === "") {
                                onChange("");
                              }
                            }}
                            inputProps={{ min: 0, max: 5 }}
                            error={!!errors.isthriller}
                            helperText={errors.isthriller?.message}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </TabContainer>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ویرایش
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        )}
        {tabValue === 1 && (
          <form id="form2" onSubmit={handleSubmit2(onSubmit2)}>
            <Modal.Body>
              <Paper className="tab-noStyle">
                <Tabs value={tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
                  <Tab label="ویرایش نظر" />
                  <Tab label="پاسخ به نظر" />
                </Tabs>
              </Paper>

              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <Row>
                    <Col xs="12">
                      <Controller
                        name="name"
                        control={control2}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors2.name && <span>لطفا نام را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="text"
                        control={control2}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="متن نظر"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            multiline
                            rowsMax="10"
                            value={value || ""}
                            onInput={onChange}
                            sx={{
                              ".css-1ppugi6-MuiInputBase-root-MuiOutlinedInput-root": {
                                padding: "8.5px 14px 8.5px 0px !important",
                              }
                            }}
                          />
                        )}
                      />
                      {errors2.text && <span>لطفا متنی را وارد نمایید</span>}
                    </Col>
                  </Row>
                </Col>
              </TabContainer>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting2}>
                {isSubmitting2 && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        )}
      </Modal>
    </div>
  );
};
